import * as React from 'react';
import {Form} from 'antd';
import {FormComponentProps} from 'antd/lib/form';

import {SaveWarehouseRequest, Warehouse} from '../api/dtos/dtos';
import locales from '../locales';
import InputFormItem from '../common/form-items/InputFormItem';
import CheckBoxFormItem from '../common/form-items/CheckBoxFormItem';
import SubmitCancelFormItem from '../common/form-items/SubmitCancelFormItem';

interface WarehouseFormProps extends FormComponentProps {
  warehouse?: Warehouse;
  forcedDefault?: boolean;
  onFormSubmit?: (request: SaveWarehouseRequest) => void;
  onFormCancel: () => void;
}

const FIELD_NAME = 'name';
const FIELD_DEFAULT = 'default';

class WarehouseForm extends React.Component<WarehouseFormProps, {}> {

  public render() {
    const {form, warehouse, forcedDefault} = this.props;
    return (
      <Form>
        <InputFormItem
          form={form}
          fieldId={FIELD_NAME}
          label={locales.name}
          initialValue={warehouse?.name}
          required={true}
        />

        <CheckBoxFormItem
          form={form}
          fieldId={FIELD_DEFAULT}
          label={locales.warehouse_default}
          initialValue={warehouse ? warehouse?.isDefault : forcedDefault}
          required={false}
          disabled={forcedDefault || warehouse?.isDefault}
        />

        <SubmitCancelFormItem onSubmit={this.onFormSubmit} onCancel={this.onFormCancel}/>
      </Form>
    );
  }

  private onFormCancel = () => {
    this.props.form.resetFields();
    this.props.onFormCancel();
  };

  private onFormSubmit = () => {
    const {form, warehouse, onFormSubmit} = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        onFormSubmit?.({
          id: warehouse?.id,
          name: values[FIELD_NAME],
          isDefault: values[FIELD_DEFAULT],
        });
      }
    });
  };
}

export default Form.create<WarehouseFormProps>()(WarehouseForm);




// WEBPACK FOOTER //
// ./src/warehouse/WarehouseForm.tsx